// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2fQk0","title":"Images90_title__2iMLx","images":"Images90_images__3Hq58"};